import React, { useState } from "react";
import { ChevronRight, Download, ChevronLeft, Building2, MapPin, Users, ScrollText, DollarSign, FileText, Loader2, CheckCircle, Building, Award, Mail, Briefcase, Clock, Calendar } from "lucide-react";
import * as XLSX from "xlsx";
const API = "https://aiuhf.app.n8n.cloud/webhook/2b3a902f-9397-471a-9fa8-8033e3eac08c";

function AddStaffing() {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [rankedCandidates, setRankedCandidates] = useState([]);
  const [visibleCandidates, setVisibleCandidates] = useState([]);
const [bufferCandidates, setBufferCandidates] = useState([]);

  
  const [formData, setFormData] = useState({
    position: "",
    clientName: "",
    city: "",
    country: "",
    resourcesRequired: "",
    budget: "",
    description: ""
  });


   const getActivePositions = () => {
  const stored = JSON.parse(localStorage.getItem("positions_config")) || [];
  return stored
    .filter(p => p.status === "active")
    .map(p => p.name.toLowerCase());
};

const positions = getActivePositions();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleNext = () => {
    if (!formData.position) {
      setError("Please select a position");
      return;
    }
    setStep(2);
    setError("");
  };

  const handleBack = () => {
    if (step === 2) {
      setStep(1);
    } else if (step === 3) {
      setStep(2);
    }
    setError("");
  };

  const handleNewSearch = () => {
    setFormData({
      position: "",
      clientName: "",
      city: "",
      country: "",
      resourcesRequired: "",
      budget: "",
      description: ""
    });
    setRankedCandidates([]);
    setStep(1);
    setError("");
  };

const handleDownloadExcel = () => {
    const wb = XLSX.utils.book_new();
  
  // Prepare data array
  const data = [];
  
  // CLIENT DETAILS SECTION (rows 0-6)
  data.push(['Client Name', formData.clientName]);
  data.push(['Position', formData.position]);
  data.push(['Location', `${formData.city}, ${formData.country}`]);
  data.push(['Budget per Resource', formData.budget]);
  data.push(['Number of Resources Required', formData.resourcesRequired]);
  data.push(['Requirements', formData.description]);
  data.push(['Generated Date', new Date().toLocaleString()]);
  data.push([]); // Empty row
  data.push([]); // Empty row
  
  // RESOURCE DETAILS SECTION
  const fields = [
    { label: 'Field', key: 'position' },
    { label: 'Resource Type', key: 'name' },
    { label: 'Email', key: 'email' },
    { label: 'AI Match Score', key: 'score' },
    { label: 'AI Analysis', key: 'reason' },
    { label: 'Role Description', key: 'description' },
    { label: 'Required Tech Stack / Tools', key: 'techStack' },
    { label: 'Years of Experience', key: 'experience' },
    { label: 'Work Mode (Onsite / Hybrid / Remote)', key: 'onsiteOffsite' },
    { label: 'Employer Location', key: 'location' },
    { label: 'Working Days', key: 'working_days' },
    { label: 'Working Hours', key: 'working_hours' },
    { label: 'Notice Period', key: 'noticePeriod' },
    { label: 'Reporting To', key: 'reporting_to' }
  ];
  
  // Header row for resources (row 9)
  const headerRow = ['Field', ...visibleCandidates.map((_, idx) => `Resource ${idx + 1}`)];
  data.push(headerRow);
  
  // Data rows for each field (rows 10+)
  fields.forEach(field => {
    const row = [field.label];
    
    visibleCandidates.forEach(candidate => {
      let value = '';
      
      if (field.key === 'position') {
        value = formData.position;
      } else if (field.key === 'score') {
        value = candidate[field.key] ? `${candidate[field.key]}%` : 'N/A';
      } else {
        value = candidate[field.key] || 'Not specified';
      }
      
      row.push(value);
    });
    
    data.push(row);
  });
  
  // Create worksheet from data
  const ws = XLSX.utils.aoa_to_sheet(data);
  
  // Set column widths
  const colWidths = [{ wch: 35 }]; // Column A
 for (let i = 0; i < visibleCandidates.length; i++) {
    colWidths.push({ wch: 50 }); // Columns B, C, D, etc.
  }
  ws['!cols'] = colWidths;
  
  // Apply styling to all cells
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cellAddress]) continue;
      
      if (!ws[cellAddress].s) ws[cellAddress].s = {};
      
      // Apply text wrapping and vertical alignment to ALL cells
      ws[cellAddress].s.alignment = {
        wrapText: true,
        vertical: 'top',
        horizontal: 'left'
      };
      
      // CLIENT DETAILS SECTION (rows 0-6) - Light blue background for column A
      if (R <= 6 && C === 0) {
        ws[cellAddress].s.fill = {
          fgColor: { rgb: "B4C7E7" } // Light blue
        };
        ws[cellAddress].s.font = {
          bold: true,
          color: { rgb: "000000" }
        };
      }
      
      // RESOURCE SECTION - Column A gets orange background (rows 9+)
      if (R >= 9 && C === 0) {
        ws[cellAddress].s.fill = {
          fgColor: { rgb: "F4B084" } // Light orange
        };
        ws[cellAddress].s.font = {
          bold: true,
          color: { rgb: "000000" }
        };
      }
    }
  }
  
  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Staffing Report');
  
  // Generate filename
  const fileName = `Staffing_Report_${formData.position.replace(/\s+/g, '_')}_${formData.clientName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
  
  // Write the file
  XLSX.writeFile(wb, fileName);
};
const handleReplaceCandidate = (index) => {
  if (bufferCandidates.length === 0) return;

  const nextBest = bufferCandidates[0];

  setVisibleCandidates(prev => {
    const updated = [...prev];
    updated[index] = nextBest;
    return updated;
  });

  setBufferCandidates(prev => prev.slice(1));
};

  const submitForm = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.clientName || !formData.city || !formData.country || 
        !formData.resourcesRequired || !formData.budget || !formData.description) {
      setError("Please fill all required fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          position: formData.position,
          clientName: formData.clientName,
          location: {
            city: formData.city,
            country: formData.country
          },
          resourcesRequired: parseInt(formData.resourcesRequired),
          description: formData.description,
          budget: parseFloat(formData.budget)
        })
      });

      const data = await response.json();
      
      if (data.success && data.rankedCandidates) {
        const required = parseInt(formData.resourcesRequired, 10);

setVisibleCandidates(data.rankedCandidates.slice(0, required));
setBufferCandidates(data.rankedCandidates.slice(required));
setRankedCandidates(data.rankedCandidates); // keep full list for Excel

setStep(3);
 // Move to results page
      } else {
        setError(data.message || "Failed to fetch candidates");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getScoreColor = (score) => {
    if (score >= 90) return '#10b981'; // Green
    if (score >= 75) return '#3b82f6'; // Blue
    if (score >= 60) return '#f59e0b'; // Orange
    return '#ef4444'; // Red
  };

  const getScoreBadgeStyle = (score) => ({
    ...styles.scoreBadge,
    backgroundColor: getScoreColor(score) + '20',
    color: getScoreColor(score),
    border: `2px solid ${getScoreColor(score)}`,
  });

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerContent}>
            <div style={styles.iconCircle}>
              <Users size={32} color="#fff" />
            </div>
            <div>
              <h1 style={styles.title}>Add New Staffing</h1>
              <p style={styles.subtitle}>Find the perfect candidates for your project</p>
            </div>
          </div>
        </div>

        {/* Progress Indicator */}
        <div style={styles.progressContainer}>
          <div style={styles.progressBar}>
            <div style={{...styles.progressStep, ...(step >= 1 ? styles.progressStepActive : {})}}>
              <div style={{
                ...styles.stepNumber,
                ...(step >= 1 ? {background: 'linear-gradient(135deg, #004687, #003366)', color: '#fff'} : {})
              }}>1</div>
              <span style={styles.stepLabel}>Position</span>
            </div>
            <div style={{...styles.progressLine, ...(step >= 2 ? styles.progressLineActive : {})}}></div>
            <div style={{...styles.progressStep, ...(step >= 2 ? styles.progressStepActive : {})}}>
              <div style={{
                ...styles.stepNumber,
                ...(step >= 2 ? {background: 'linear-gradient(135deg, #004687, #003366)', color: '#fff'} : {})
              }}>2</div>
              <span style={styles.stepLabel}>Details</span>
            </div>
            <div style={{...styles.progressLine, ...(step >= 3 ? styles.progressLineActive : {})}}></div>
            <div style={{...styles.progressStep, ...(step >= 3 ? styles.progressStepActive : {})}}>
              <div style={{
                ...styles.stepNumber,
                ...(step >= 3 ? {background: 'linear-gradient(135deg, #004687, #003366)', color: '#fff'} : {})
              }}>3</div>
              <span style={styles.stepLabel}>Results</span>
            </div>
          </div>
        </div>

        {/* Form Card */}
        <div style={styles.formCard}>
          {/* Step 1: Position Selection */}
          {step === 1 && (
            <div style={styles.stepContainer}>
              <h2 style={styles.stepTitle}>Select Position</h2>
              <p style={styles.stepDescription}>Choose the position you need to fill</p>
              
              <div style={styles.formGroup}>
                <label style={styles.label}>
                  Position <span style={styles.required}>*</span>
                </label>
                <div style={styles.selectWrapper}>
                  <select
                    name="position"
                    value={formData.position}
                    onChange={handleInputChange}
                    style={styles.select}
                  >
                    <option value="">-- Choose a Position --</option>
                    {positions.map((pos) => (
                      <option key={pos} value={pos}>
                        {pos}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {error && (
                <div style={styles.errorMessage}>
                  ⚠️ {error}
                </div>
              )}

              <div style={styles.buttonGroup}>
                <button
                  onClick={handleNext}
                  style={{...styles.button, ...styles.primaryButton}}
                  disabled={!formData.position}
                >
                  Next
                  <ChevronRight size={20} style={styles.buttonIcon} />
                </button>
              </div>
            </div>
          )}

          {/* Step 2: Client Details */}
          {step === 2 && (
            <div style={styles.stepContainer}>
              <h2 style={styles.stepTitle}>Client Details & Requirements</h2>
              <p style={styles.stepDescription}>Provide detailed information about your staffing needs</p>
              
              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <Building2 size={16} style={styles.labelIcon} />
                    Client Name <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="clientName"
                    value={formData.clientName}
                    onChange={handleInputChange}
                    placeholder="Enter client name"
                    style={styles.input}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <Users size={16} style={styles.labelIcon} />
                    Number of Resources <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="number"
                    name="resourcesRequired"
                    value={formData.resourcesRequired}
                    onChange={handleInputChange}
                    placeholder="e.g., 4"
                    min="1"
                    max="50"
                    style={styles.input}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <MapPin size={16} style={styles.labelIcon} />
                    City <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="e.g., Dubai"
                    style={styles.input}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <MapPin size={16} style={styles.labelIcon} />
                    Country <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    placeholder="e.g., UAE"
                    style={styles.input}
                  />
                </div>

                <div style={{...styles.formGroup, gridColumn: '1 / -1'}}>
                  <label style={styles.label}>
                    <DollarSign size={16} style={styles.labelIcon} />
                    Budget <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="number"
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    placeholder="e.g., 5000"
                    min="0"
                    step="100"
                    style={styles.input}
                  />
                </div>

                <div style={{...styles.formGroup, gridColumn: '1 / -1'}}>
                  <label style={styles.label}>
                    <FileText size={16} style={styles.labelIcon} />
                    Requirements Description <span style={styles.required}>*</span>
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Describe specific requirements, skills, experience level, technologies, etc."
                    rows="6"
                    style={styles.textarea}
                  />
                  <p style={styles.hint}>
                    💡 Be specific about required technologies, experience level, and any special requirements
                  </p>
                </div>
              </div>

              {error && (
                <div style={styles.errorMessage}>
                  ⚠️ {error}
                </div>
              )}

              <div style={styles.buttonGroup}>
                <button
                  onClick={handleBack}
                  style={{...styles.button, ...styles.secondaryButton}}
                  disabled={loading}
                >
                  <ChevronLeft size={20} style={styles.buttonIcon} />
                  Back
                </button>
                <button
                  onClick={submitForm}
                  style={{...styles.button, ...styles.primaryButton}}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Loader2 size={20} style={{...styles.buttonIcon, animation: 'spin 1s linear infinite'}} />
                      Analyzing...
                    </>
                  ) : (
                    <>
                      Find Candidates
                      <ChevronRight size={20} style={styles.buttonIcon} />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}

          {/* Step 3: Results */}
          {step === 3 && (
            <div style={styles.stepContainer}>
              <div style={styles.resultsHeader}>
                <div>
                  <h2 style={styles.stepTitle}>Ranked Candidates</h2>
                  <p style={styles.stepDescription}>
                    Position: <strong>{formData.position}</strong> | Client: <strong>{formData.clientName}</strong>
                  </p>
                </div>
                <div style={styles.candidateCount}>
                  {rankedCandidates.length} Candidate{rankedCandidates.length !== 1 ? 's' : ''} Found
                </div>
              </div>

              {rankedCandidates.length === 0 ? (
                <div style={styles.noCandidates}>
                  <Users size={48} color="#94a3b8" />
                  <p>No candidates found matching your criteria</p>
                </div>
              ) : (
                <div style={styles.candidatesList}>
                  {visibleCandidates.map((candidate, index) => (
                    <div key={index} style={styles.candidateCard}>
                    <div style={styles.candidateHeader}>
  <div style={styles.candidateRank}>
    <Award size={24} color="#004687" />
    <span style={styles.rankNumber}>#{index + 1}</span>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
    <div style={getScoreBadgeStyle(candidate.score)}>
      <strong>{candidate.score}%</strong> Match
    </div>

    {/* 🔁 Replace Button */}
    <button
      onClick={() => handleReplaceCandidate(index)}
      disabled={bufferCandidates.length === 0}
      style={{
        padding: "8px 14px",
        background:
          bufferCandidates.length === 0
            ? "#e5e7eb"
            : "linear-gradient(135deg, #f97316, #ea580c)",
        color: bufferCandidates.length === 0 ? "#9ca3af" : "#fff",
        border: "none",
        borderRadius: "10px",
        cursor:
          bufferCandidates.length === 0 ? "not-allowed" : "pointer",
        fontSize: "13px",
        fontWeight: 600,
        whiteSpace: "nowrap"
      }}
    >
      🔄 Replace
    </button>
  </div>
</div>


                      <div style={styles.candidateInfo}>
                        <h3 style={styles.candidateName}>{candidate.name || `Candidate ${index + 1}`}</h3>
                        
                        {candidate.email && (
                          <div style={styles.infoRow}>
                            <Mail size={16} color="#004687" />
                            <span>{candidate.email}</span>
                          </div>
                        )}

                     {candidate.experience && (
                        <div style={styles.infoRow}>
                          <Briefcase size={16} color="#004687" />
                          <p>Experience: {candidate.experience}</p>
                        </div>
                      )}

                        {candidate.location && (
                          <div style={styles.infoRow}>
                            <MapPin size={16} color="#004687" />
                            <span>{candidate.location}</span>
                          </div>
                        )}

                        {candidate.onsiteOffsite && (
                          <div style={styles.infoRow}>
                            <Building size={16} color="#004687" />
                            <span>Onsite/Offsite/Hybrid: {candidate.onsiteOffsite}</span>
                          </div>
                        )}

                      {candidate.working_hours && (
                          <div style={styles.infoRow}>
                            <Calendar size={16} color="#004687" />
                            <span>Working Hours: {candidate.working_hours}</span>
                          </div>
                        )}

                      {candidate.working_days && (
                          <div style={styles.infoRow}>
                            <Calendar size={16} color="#004687" />
                            <span>Working Days: {candidate.working_days}</span>
                          </div>
                        )}
                 
                        {candidate.noticePeriod && (
                          <div style={styles.infoRow}>
                            <Clock size={16} color="#004687" />
                            <span>Notice Period: {candidate.noticePeriod}</span>
                          </div>
                        )}
                         {candidate.reporting_to && (
                          <div style={styles.infoRow}>
                            <ScrollText size={16} color="#004687" />
                            <span>Reporting To: {candidate.reporting_to}</span>
                          </div>
                        )}
                      </div>

                      
                      {candidate.reason && (
                        <div style={styles.reasonBox}>
                          <strong style={styles.reasonTitle}>AI Analysis:</strong>
                          <p style={styles.reasonText}>{candidate.reason}</p>
                        </div>
                      )}

                      {candidate.description && (
                        <div style={styles.descriptionBox}>
                          <strong style={styles.descriptionTitle}>Description:</strong>
                          <p style={styles.descriptionText}>{candidate.description}</p>
                        </div>
                      )}

                      {candidate.techStack && (
                        <div style={styles.techStackBox}>
                          <strong style={styles.techStackTitle}>Tech Stack:</strong>
                          <p style={styles.techStackText}>{candidate.techStack}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            <div style={styles.buttonGroup}>
                <button
                  onClick={handleDownloadExcel}
                  style={{...styles.button, ...styles.successButton}}
                  disabled={rankedCandidates.length === 0}
                >
                  <Download size={20} style={styles.buttonIcon} />
                  Download Excel
                </button>
                <button
                  onClick={handleNewSearch}
                  style={{...styles.button, ...styles.primaryButton}}
                >
                  New Search
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  pageContainer: {
    minHeight: '100vh',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  container: {
    maxWidth: '1100px',
    margin: '0 auto',
  },
  header: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '30px',
    marginBottom: '30px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  iconCircle: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #004687, #003366)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 10px 30px rgba(0, 70, 135, 0.4)',
  },
  title: {
    margin: 0,
    fontSize: '32px',
    fontWeight: '700',
    color: '#004687',
  },
  subtitle: {
    margin: '5px 0 0 0',
    color: '#64748b',
    fontSize: '16px',
  },
  progressContainer: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '30px',
    marginBottom: '30px',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
  },
  progressBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
  },
  progressStep: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    flex: '0 0 auto',
  },
  progressStepActive: {},
  stepNumber: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    background: '#e2e8f0',
    color: '#64748b',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: '700',
    transition: 'all 0.3s ease',
  },
  stepLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#64748b',
  },
  progressLine: {
    flex: '1',
    height: '4px',
    background: '#e2e8f0',
    borderRadius: '2px',
    transition: 'all 0.3s ease',
  },
  progressLineActive: {
    background: 'linear-gradient(90deg, #004687, #003366)',
  },
  formCard: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '40px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    animation: 'fadeIn 0.5s ease',
  },
  stepContainer: {
    animation: 'fadeIn 0.5s ease',
  },
  stepTitle: {
    margin: '0 0 10px 0',
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
  },
  stepDescription: {
        
    margin: '0 0 30px 0',
    color: '#64748b',
    fontSize: '16px',
  },
  formGroup: {
    marginBottom: '25px',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '25px',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '10px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#334155',
  },
  labelIcon: {
    color: '#004687',
  },
  required: {
    color: '#ef4444',
  },
  input: {
    width: '100%',
    
    padding: '14px 18px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    transition: 'all 0.3s ease',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    padding: '14px 18px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    transition: 'all 0.3s ease',
    fontFamily: 'inherit',
    resize: 'vertical',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  selectWrapper: {
    position: 'relative',
  },
  select: {
    width: '100%',
    padding: '14px 18px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    transition: 'all 0.3s ease',
    backgroundColor: '#fff',
    cursor: 'pointer',
    appearance: 'none',
    boxSizing: 'border-box',
  },
  hint: {
    marginTop: '8px',
    fontSize: '13px',
    color: '#64748b',
  },
  buttonGroup: {
    display: 'flex',
    gap: '15px',
    marginTop: '30px',
  },
  button: {
    flex: '1',
    padding: '16px 28px',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    outline: 'none',
  },
  primaryButton: {
    background: 'linear-gradient(135deg, #004687, #003366)',
    color: '#fff',
    boxShadow: '0 10px 30px rgba(0, 70, 135, 0.4)',
  },
  secondaryButton: {
    background: '#e2e8f0',
    color: '#475569',
  },
  buttonIcon: {
    flexShrink: 0,
  },
  errorMessage: {
    padding: '16px 20px',
    background: '#fee2e2',
    color: '#dc2626',
    borderRadius: '12px',
    marginTop: '20px',
    fontSize: '14px',
    fontWeight: '500',
    border: '2px solid #fecaca',
  },
  resultsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '30px',
    flexWrap: 'wrap',
    gap: '20px',
  },
  candidateCount: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #004687, #003366)',
    color: '#fff',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
  },
  noCandidates: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#64748b',
  },
  candidatesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  candidateCard: {
    background: '#f8fafc',
    border: '2px solid #e2e8f0',
    borderRadius: '16px',
    padding: '24px',
    transition: 'all 0.3s ease',
  },
  candidateHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '15px',
  },
  candidateRank: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  rankNumber: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#004687',
  },
  scoreBadge: {
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '600',
  },
  candidateInfo: {
    marginBottom: '20px',
  },
  candidateName: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '12px',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#475569',
    fontSize: '14px',
    marginBottom: '8px',
  },
  reasonBox: {
    background: '#dbeafe',
    border: '2px solid #93c5fd',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '15px',
  },
  reasonTitle: {
    color: '#1e40af',
    fontSize: '14px',
    display: 'block',
    marginBottom: '8px',
  },
  reasonText: {
    color: '#1e40af',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: 0,
  },
  descriptionBox: {
    background: '#fff',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '15px',
  },
  descriptionTitle: {
    color: '#334155',
    fontSize: '14px',
    display: 'block',
    marginBottom: '8px',
  },
  descriptionText: {
    color: '#64748b',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: 0,
  },
  techStackBox: {
    background: '#f1f5f9',
    border: '2px solid #cbd5e1',
    borderRadius: '12px',
    padding: '16px',
  },
  techStackTitle: {
    color: '#334155',
    fontSize: '14px',
    display: 'block',
    marginBottom: '8px',
  },
  techStackText: {
    color: '#64748b',
    fontSize: '13px',
    lineHeight: '1.6',
    margin: 0,
  },
};

export default AddStaffing;